import script from "./FormulasIngredientTeen.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientTeen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__